module.exports = __webpack_public_path__ + "img/sustainability-image-mobile.5bb0606c.png";